import React, { FC } from 'react';
import { Alert, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BatchSkippedOrder } from 'models/order';

type BatchSkippedOrdersProps = {
    skipped: BatchSkippedOrder[];
};

/** The orders a batch action leaves out, each with the reason it was skipped. */
const BatchSkippedOrders: FC<BatchSkippedOrdersProps> = ({ skipped }: BatchSkippedOrdersProps) => {
    const { t: translate } = useTranslation(['orders']);
    if (!skipped.length) {
        return null;
    }
    return (
        <Alert severity="warning" sx={{ mt: 2 }} data-test="batch-skipped-orders">
            <Typography variant="subtitle2">{translate('orders:BATCH_SKIPPED_ORDERS')}</Typography>
            <Box component="ul" sx={{ m: 0, pl: 2 }}>
                {skipped.map((order) => (
                    <li key={order._id}>
                        {order.orderId}: {translate(`orders:BATCH_SKIP_REASON_${order.reason}`)}
                    </li>
                ))}
            </Box>
        </Alert>
    );
};

export default BatchSkippedOrders;
